import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { css } from "styled-components";

productCountStyles.countText = {
    css: css`
        white-space: nowrap;
        font-family: "Lato";
        color: #17313e;
    `,
};

productCountStyles.queryText = {
    css: css`
        white-space: nowrap;
        font-family: "LatoBold";
    `,
};
